// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type
// export interface EmployeeIncidentFormData {
//   id?: string;
//   date: string;
//   time: string;
//   location: string;
//   employee_name: string;
//   job_title: string;
//   description: string;
//   other_individuals?: string;
//   witnesses: string;
//   witness_contacts?: string;
//   immediate_actions: string;
//   reported_to_management: string;
//   manager_name?: string;
//   reporting_datetime?: string;
//   recommendations: string;
//   employee_signature: string;
//   date_completed: string;
//   photo?: File|string;
//   client_email?: string;
// }

// // Define the state type
// interface EmployeeIncidentState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: EmployeeIncidentState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// // Async thunk for posting employee incident data
// export const submitEmployeeIncident = createAsyncThunk<
//   { message: string },
//   EmployeeIncidentFormData,
//   { rejectValue: string }
// >('employeeIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing group_id, service_id, or client_email in localStorage');
//     }

//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }

//     const payload = {
//       id: formData.id,
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date,
//       time: formData.time,
//       location: formData.location,
//       employee_name: formData.employee_name,
//       job_title: formData.job_title,
//       description: formData.description,
//       other_individuals: formData.other_individuals || '',
//       witnesses: formData.witnesses,
//       witness_contacts: formData.witness_contacts || '',
//       immediate_actions: formData.immediate_actions,
//       reported_to_management: formData.reported_to_management,
//       manager_name: formData.manager_name || '',
//       reporting_datetime: formData.reporting_datetime || '',
//       recommendations: formData.recommendations,
//       employee_signature: formData.employee_signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post('/ndis/form/employee-incident', payload, {
//       headers: { 'Content-Type': 'application/json' }
//     });
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(
//       error.response?.data?.message || 'Failed to submit employee incident report'
//     );
//   }
// });

// const employeeIncidentSlice = createSlice({
//   name: 'employeeIncident',
//   initialState,
//   reducers: {
//     clearEmployeeIncidentState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitEmployeeIncident.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitEmployeeIncident.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Employee incident reported successfully';
//         state.error = null;
//       })
//       .addCase(submitEmployeeIncident.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearEmployeeIncidentState } = employeeIncidentSlice.actions;
// export default employeeIncidentSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type
export interface EmployeeIncidentFormData {
  id?: string;
  date: string;
  time: string;
  location: string;
  employee_name: string;
  job_title: string;
  description: string;
  other_individuals?: string;
  witnesses: string;
  witness_contacts?: string;
  immediate_actions: string;
  reported_to_management: string;
  manager_name?: string;
  reporting_datetime?: string;
  recommendations: string;
  employee_signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
  resolved?: string; // Added resolved field
}

// Define the state type
interface EmployeeIncidentState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: EmployeeIncidentState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for posting employee incident data
export const submitEmployeeIncident = createAsyncThunk<
  { message: string },
  EmployeeIncidentFormData,
  { rejectValue: string }
>('employeeIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing group_id, service_id, or client_email in localStorage');
    }

    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    const payload = {
      id: formData.id,
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date,
      time: formData.time,
      location: formData.location,
      employee_name: formData.employee_name,
      job_title: formData.job_title,
      description: formData.description,
      other_individuals: formData.other_individuals || '',
      witnesses: formData.witnesses,
      witness_contacts: formData.witness_contacts || '',
      immediate_actions: formData.immediate_actions,
      reported_to_management: formData.reported_to_management,
      manager_name: formData.manager_name || '',
      reporting_datetime: formData.reporting_datetime || '',
      recommendations: formData.recommendations,
      employee_signature: formData.employee_signature,
      date_completed: formData.date_completed,
      photo: photoField,
      resolved: formData.resolved || '' // Include resolved in payload
    };

    const response = await axiosInstance.post('/ndis/form/employee-incident', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message || 'Failed to submit employee incident report'
    );
  }
});

const employeeIncidentSlice = createSlice({
  name: 'employeeIncident',
  initialState,
  reducers: {
    clearEmployeeIncidentState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitEmployeeIncident.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitEmployeeIncident.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Employee incident reported successfully';
        state.error = null;
      })
      .addCase(submitEmployeeIncident.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearEmployeeIncidentState } = employeeIncidentSlice.actions;
export default employeeIncidentSlice.reducer;